<template>
    <section>
        <div class="abo-detail-box row">
            <data-entry-column v-if="entry" :title="$t('pds.details.price_per_km')" :value="getAdditionalCosts"
                :is-loading="isLoading"></data-entry-column>
            <data-entry-column :title="$t('pds.details.min_age')" :value="getAge" :is-loading="isLoading"
                v-if="getAge"></data-entry-column>
            <data-entry-column v-if="entry && !this.$root.whitelabel.isUs()" :title="$t('pds.details.participation')"
                :value="getParticipation" :is-loading="isLoading"></data-entry-column>
            <data-entry-column v-if="entry && this.$root.whitelabel.isUs()" :title="$t('pds.details.membership.fee')"
                :value="getParticipation" :is-loading="isLoading"></data-entry-column>
            <data-entry-column v-if="entry && this.$root.whitelabel.setting('deposit')"
                :title="$t('pds.details.deposit')" :value="getDeposit" :is-loading="isLoading"></data-entry-column>
        </div>
        <div class="row">
            <div class="col-12">
                <data-entry-column v-if="getMinLicenseDuration" :title="$t('pds.details.min_license_duration')"
                    :full-width="true" :value="getMinLicenseDuration" :is-loading="isLoading"></data-entry-column>
            </div>
        </div>

        <div class="row" v-if="entry && this.$root.whitelabel.setting('deposit')">
            <div class="col-12">
                {{ $t('pds.details.deposit_note') }}
            </div>
        </div>
    </section>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'AboDetailsBox',
    components: {
        DataEntryColumn,
    },
    props: {
        entry: null,
        isLoading: true
    },
    computed: {
        withoutTax() {
            return this.$root.whitelabel.setting('show_price_without_taxes')
        },
        getMinLicenseDuration() {
            return this.entry && this.entry.min_license_duration ? `${this.entry.min_license_duration} ${this.$t('pds.details.years')}` : ''
        },
        getAdditionalCosts() {
            if(this.entry) {
                const costs = this.withoutTax ? this.entry.additional_mileage_costs.costs_net : this.entry.additional_mileage_costs.costs
                const taxes = this.withoutTax ? this.$t('general.net') : ''
                return `${this.$root.whitelabel.getFormatetPrice(costs)} ${taxes}`
            }

            return ''
        },
        getAge(){
            return this.entry && this.entry.minimum_age ? `${this.entry.minimum_age.min_age} ${this.$t('pds.details.years')}` : this.$t('pds.details.not_specified')
        },
        getParticipation(){
            return this.entry.damage_participation ? this.$root.whitelabel.getFormatetPrice(this.entry.damage_participation.participation) : ''
        },
        getDeposit(){
            if (!this.entry) {
                return ''
            }

            if (this.$root.whitelabel.setting('deposit').type === 'fixed') {
                return this.$root.whitelabel.getFormatetPrice(this.$root.whitelabel.setting('deposit').amount)
            }
            return this.$t('pds.details.deposit.one_month_rent');
        }
    }
}
</script>
